import { render } from "./Mb023.vue?vue&type=template&id=3ab677b0&scoped=true"
import script from "./Mb023.vue?vue&type=script&lang=js"
export * from "./Mb023.vue?vue&type=script&lang=js"

import "./Mb023.vue?vue&type=style&index=0&id=3ab677b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab677b0"]])

export default __exports__